import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseUrl, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const instance = createAxiosClient({
    baseURL: "" + baseUrl,
    withCredentials: true,
    ...axiosConfig
  }, config);

  function getEmailCount(email) {
    return instance.post("carlead/count/email", {
      email
    });
  }

  return {
    getEmailCount
  };
}